"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.User = void 0;
const sdk_1 = require("../sdk");
var User;
(function (User) {
    User.get = () => {
        const url = '/user';
        return sdk_1.SDK.axios.get(url);
    };
    User.getAccounts = () => {
        const url = '/user/accounts';
        return sdk_1.SDK.axios.get(url);
    };
    User.isAdmin = () => {
        const url = '/user/is-admin';
        return sdk_1.SDK.axios.get(url);
    };
    User.accessMode = (id) => {
        const url = `/user/access-mode/${id}`;
        return sdk_1.SDK.axios.get(url);
    };
})(User = exports.User || (exports.User = {}));
//# sourceMappingURL=user.js.map